
import { useState } from 'react';

export function useFormState<T>(initialState: T) {
  const [state, setState] = useState<T>(initialState);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    event.preventDefault();
    const { name, value } = event.target;
    setState(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const setField = (name: keyof T, value: any) => {
    setState(prev => ({
      ...prev,
      [name]: value
    }));
  };
console.log('1')
  return { state, setState, handleChange, setField };
}

  